import React from 'react';
import { Row } from '../../components/Grid';
import { ContentHeader } from '../../components/layout/ContentHeader';
import { MagazinPages } from '../../components/layout/MagazinPages';
import { Section } from '../../components/Section';
import { withErrorBoundary } from '../../error-handling/withErrorBoundary';
import { CType } from '../../provider/Typo3Provider/types';

export type MagazineTeaserContainerProps = CType;

const MagazineTeaserContainer = (props: MagazineTeaserContainerProps) => {
  return (
    <Section>
      <ContentHeader {...props} />
      <Row>{props.pages && <MagazinPages pages={props.pages} />}</Row>
    </Section>
  );
};

export default withErrorBoundary(
  MagazineTeaserContainer,
  'MagazineTeaserContainer'
);
